/**
 * The same-origin message a signing return page posts to its host (handover §5, FROZEN).
 *
 * It says "the user left the provider UI" and nothing more. It is never evidence of a signature
 * (handover §0): the host re-reads `signers[]` from the server.
 */
export const SIGNING_RETURN_MESSAGE_TYPE = 'entite.signing.return';

export const SIGNING_RETURN_OUTCOMES = ['done', 'declined', 'closed'] as const;
export type SigningReturnOutcome = (typeof SIGNING_RETURN_OUTCOMES)[number];

export interface SigningReturnMessage {
  type: typeof SIGNING_RETURN_MESSAGE_TYPE;
  outcome: SigningReturnOutcome;
}

export function isSigningReturnOutcome(value: unknown): value is SigningReturnOutcome {
  return (
    typeof value === 'string' && (SIGNING_RETURN_OUTCOMES as readonly string[]).includes(value)
  );
}

export function isSigningReturnMessage(data: unknown): data is SigningReturnMessage {
  if (typeof data !== 'object' || data === null) return false;
  const { type, outcome } = data as { type?: unknown; outcome?: unknown };
  return type === SIGNING_RETURN_MESSAGE_TYPE && isSigningReturnOutcome(outcome);
}
